import { render } from "./AddModal.vue?vue&type=template&id=a7b7e7b2&scoped=true"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"

import "./AddModal.vue?vue&type=style&index=0&id=a7b7e7b2&lang=less"
import "./AddModal.vue?vue&type=style&index=1&id=a7b7e7b2&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b7e7b2"]])

export default __exports__